import React from 'react';
import { motion } from 'framer-motion';
import { FiChevronRight } from 'react-icons/fi';

interface SubModuleCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  color: string;
  onClick: () => void;
  badge?: string;
}

const SubModuleCard: React.FC<SubModuleCardProps> = ({ icon, title, description, color, onClick, badge }) => (
  <motion.div
    whileHover={{
      y: -2,
      boxShadow: '0 8px 24px rgba(27, 42, 74, 0.1)',
    }}
    onClick={onClick}
    style={{
      background: 'var(--color-surface)',
      border: '1px solid var(--color-border-light)',
      borderRadius: 'var(--radius-lg)',
      padding: '1.5rem',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '1rem',
      transition: 'all 0.2s ease',
      position: 'relative',
    }}
    onMouseEnter={(e) => {
      (e.currentTarget as HTMLElement).style.borderColor = 'rgba(78, 205, 196, 0.4)';
    }}
    onMouseLeave={(e) => {
      (e.currentTarget as HTMLElement).style.borderColor = 'var(--color-border-light)';
    }}
  >
    <div style={{
      width: 48, height: 48, borderRadius: 'var(--radius-md)',
      background: color + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    }}>
      <span style={{ color }}>{icon}</span>
    </div>
    <div style={{ flex: 1 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.375rem' }}>
        <h3 style={{ fontSize: 'var(--font-size-base)', fontWeight: 600, margin: 0 }}>{title}</h3>
        {badge && (
          <span style={{
            fontSize: '0.65rem', fontWeight: 600, padding: '0.125rem 0.5rem',
            borderRadius: 'var(--radius-full)', background: color + '22', color,
          }}>{badge}</span>
        )}
      </div>
      <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)', margin: 0 }}>
        {description}
      </p>
    </div>
    <FiChevronRight size={18} style={{ color: 'var(--color-text-muted)', flexShrink: 0, marginTop: 4 }} />
  </motion.div>
);

export default SubModuleCard;
